import { cn } from "../../utils/cn.util";
import { Image as BaseImage } from "../image";
import { useAvatarContext } from "./Root";
import { avatarStyles } from "./styles";
import { isImageUrl } from "./utils";

export interface AvatarIndicatorProps {
  className?: string;
  src?: string;
}

export const Indicator = (props: AvatarIndicatorProps) => {
  const { size, isOnline } = useAvatarContext();
  const isCompanyIndicator = isOnline === undefined;
  const connectionStatus = isOnline ? "online" : "offline";
  const onlineStatus = isCompanyIndicator ? undefined : connectionStatus;
  // Truthiness alone isn't enough: `src` comes from API fields (`logoUrl`, `avatarUrl`) that can hold
  // something other than a URL, and the browser resolves such a value against the current path. On a
  // dynamic route that request matches the route again and the server renders the whole page a second
  // time, for a result nothing uses. Anything that isn't a URL renders as the plain indicator circle,
  // which is what an absent logo already looks like.
  const showLogo = isCompanyIndicator && !!props.src && isImageUrl(props.src);

  return (
    <div
      className={cn(
        "absolute right-0 bottom-0 overflow-hidden rounded-full border-[1.5px] border-white",
        isCompanyIndicator
          ? avatarStyles({ companyIconSize: size })
          : avatarStyles({
              connectionStatus: onlineStatus,
              connectionIconSize: size,
            }),
        "text-neutral-50",
        props.className
      )}
    >
      {/* Filled and cropped to the circle: a logo is rarely square, and left at its own size it sits in a corner. */}
      {showLogo && <BaseImage src={props.src} alt="company-logo" className="size-full object-cover" />}
    </div>
  );
};

export default Indicator;
